import React from 'react';

import { useNavigate } from 'react-router-dom';
import i18n from '../utils/i18n';
import Button from './Button';

const BecomeCreatorBanner = () => {
  const navigate = useNavigate();

  return (
    <div className="d-flex flex-column justify-content-center align-items-center mb-4">
      <img
        alt=""
        src="assets/images/become-creator-bg.jpg"
        style={{
          width: 250,
          height: 250,
          borderRadius: 50,
        }}
      />
      <Button onClick={() => navigate('/creator')} style={{ margin: 10 }}>
        {i18n.t<string>('BecomeCreatorBanner.button')}
      </Button>
    </div>
  );
};

export default BecomeCreatorBanner;
